export default "__VITE_ASSET__05009caa__"